<template>
    <div class="contacts">
        <div class="contacts__search">
            <div class="contacts__search-item">
                <z-input
                    v-model="input"
                    name=""
                    placeholder="Поиск"
                />
                <z-icon
                    name="magnifying_glass"
                    dir="top"
                    width="24"
                    height="24"
                ></z-icon>
            </div>
        </div>
        <div v-show="isFiltersChanged">
            <z-caption
                tag="p"
                size="xs"
                class="contacts__count">
                Всего: {{ filteredContacts.length }} <br/>
            </z-caption>
            <z-contact-card v-for="(contact, idx) in filteredContacts"
                    :key="idx"
                    horizontal
                    :title="contact.name"
                    :subtitle="contact.speciality"
                    :phone="contact.phones"
                    :email="[{
                    value: contact.email,
                }]">
                <p v-if="contact.description">
                    <span class="u-medium" v-html="contact.descriptionTitle"></span><br>
                    <span v-html="contact.description"></span>
                </p>
            </z-contact-card>
        </div>
        <z-accordion v-show="!isFiltersChanged">
            <z-accordion-item v-for="(item, index) in data" :key="index" :id="item.id">
                <template v-slot:header>
                    <span v-html="item.title"></span>
                </template>
                <template v-slot:body>
                    <z-contact-card v-for="(contact, idx) in item.contacts"
                        :key="idx"
                        horizontal
                        :title="contact.name"
                        :subtitle="contact.speciality"
                        :phone="contact.phones"
                        :email="[{
                        value: contact.email,
                    }]">
                        <p v-if="contact.description">
                            <span class="u-medium" v-html="contact.descriptionTitle"></span><br>
                            <span v-html="contact.description"></span>
                        </p>
                    </z-contact-card>
                </template>
            </z-accordion-item>
        </z-accordion>
    </div>
</template>

<script>
import {contactsData} from './contacts-data.js'

export default {
    name: 'contacts',
    data () {
        return {
            data: contactsData,
            count: '',
            input: '',
            contacts: []
        }
    },

    methods: {
        getContacts: function () {
            for (let child in this.data) {
                this.data[child].contacts.forEach(e => {
                    this.contacts.push(e)
                })
            }
        },
        isIncludes: function (str) {
            return str.toLowerCase().includes(this.input.toLowerCase())
        }
    },

    computed: {
        isFiltersChanged () {
            return this.input.length > 0
        },
        filteredContacts () {
            if (this.input !== '') {
                return this.contacts.filter(item => {
                    for (let key in item) {
                        if (typeof item[key] === 'string') {
                            if (this.isIncludes(item[key])) {
                                return true
                            }
                        }
                        if (typeof item[key] === 'object') {
                            for (let i in item[key]) {
                                for (let k in item[key][i]) {
                                    if (this.isIncludes(item[key][i][k])) {
                                        return true
                                    }
                                }
                            }
                        }
                    }
                })
            }
            return this.contacts
        }
    },

    mounted () {
        this.getContacts()
    }
}
</script>

<style lang="scss">
.contacts {

    &__count {
        font-size: 18px;
        line-height: 140%;
        color: $token-colors-black-60;
        margin-bottom: $token-spacers-m;
        margin-top: 0 !important;
    }

    &__search {
        display: flex;
        justify-content: space-between;
        width: 100%;
        flex-wrap: wrap;

        &-item {
            margin-bottom: $token-spacers-2-xs;
            padding: 0;
            width: 100%;
            position: relative;

            .z-icon {
                position: absolute;
                right: 10px;
                top: 55%;
                transform: translate(0, -75%);
            }
        }
    }
}
</style>
